import { Spinner } from '@/components/spinner'
import { cn } from '@/lib/utils'

import { LoadingComponentProps } from './types'

export function LoadingComponent({
  className,
  spinnerClassName,
  ...props
}: LoadingComponentProps) {
  return (
    <div
      className={cn(
        'absolute inset-0 flex min-h-screen items-center justify-center bg-background',
        className,
      )}
      {...props}
    >
      <Spinner className={cn('h-32 w-32', spinnerClassName)} />
    </div>
  )
}
